const $ = jQuery;

export default function () {
    if (!$('.card-team').length) return;

    // Open card on hover
    $(document).on('mouseenter', '.card-team', function () {
        // Close any other open cards first
        $('.card-team.is-open')
            .not(this)
            .each(function () {
                closeCard($(this));
            });
        // Open the current card
        openCard($(this));
    });

    // Close card when mouse leaves
    $(document).on('mouseleave', '.card-team', function () {
        closeCard($(this));
    });
}

// Helper function to open a specific card
const openCard = ($card) => {
    if (!$card.hasClass('is-open')) {
        $card.addClass('is-open');
        $card.find('.card-team__heading').slideUp();
        $card.find('.card-team__content').slideDown();
    }
};

// Helper function to close a specific card
const closeCard = ($card) => {
    if ($card.hasClass('is-open')) {
        $card.removeClass('is-open');
        $card.find('.card-team__heading').slideDown();
        $card.find('.card-team__content').slideUp();
    }
};
